/**
 * The words of the game window's frame (P1.9-T182): what the title says its keys do and the grip's name. Drafts for
 * the author.
 */
export const WINDOW = {
  moveHint: "Arrow keys move this window, 8 pixels with Shift. Home returns it to its place. The corner grip resizes it with the arrow keys.",
  gripLabel: "Resize window. Drag, or press the arrow keys",
  gripLabelTouch: "Resize window. Drag",
} as const;
